import API from '../api';

export default class CoursePaymentService {
  constructor() {
    this.API = new API();
  }

  purchaseCourse = (courseId, body) => this.API.post(`/coursePayment/${courseId}/`, body);

  updateCoursePaymentTransaction = (body) => this.API.post('/coursePayment/updateTransaction', body);
}
